import React from 'react';
import { Checkbox } from 'rsuite5';
import { ValueType } from 'rsuite5/esm/Checkbox';

const BicesterCheckbox = ({
  checked,
  className,
  style,
  onChange,
  children,
  ...props
}: {
  checked: boolean;
  className?: string;
  style?: any;
  onChange?: (value: ValueType, checked: boolean, event) => void;
  children?: React.ReactNode;
  [rest: string]: any;
}) => {
  return (
    <Checkbox className={className} checked={checked} style={style} onChange={onChange} {...props}>
      {children}
    </Checkbox>
  );
};

export default BicesterCheckbox;
